import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation SendChatMessage($input: ChatMessageInput!) {
    sendChatMessage(input: $input)
  }
`);
